module.exports = __webpack_public_path__ + "img/df621a7.jpg";